/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import * as signalR from '@microsoft/signalr';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import { LeftMenu } from '@gse/react-components-dg-qa';
import jwtdecode from 'jwt-decode';
import Header from '../Header';
import { menuBackOfficeBuilt } from '../../../helpers/menuConfig';
import { API_SOCKET_ENDPOINT, API_SEGURIDAD } from '../../../config/config';
import WarningIcon from '../../IconsLibrary/WarningIcon';
import AlertConfirm from '../confirmationWindows/AlertConfirm';
import Loading from '../Loading';

const drawerWidth = 250;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
    marginRight: 10,
    backgroundColor: theme.leftMenu.backgroundColor,
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    top: '64px',
    width: drawerWidth,
    background: 'none',
    borderRight: 'none',
  },
  content: {
    flexGrow: 1,
    padding: '0px',
  },
}));

const getMulishText = (fontWeight, color, fontSize) => ({
  fontFamily: 'Mulish, sans-serif',
  fontSize,
  fontWeight,
  color,
});
const messageStyle = (
  theme,
  firstImageIcon,
  marginTopImage,
  minWidth,
  minHeight,
  paddingBottom = 16,
) => ({
  firstImage: firstImageIcon,
  styleMessage: {
    ...getMulishText(700, '#575756', '18px'),
    paddingBottom,
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingTop: '1px',
  },
  firstImageStyles: {
    display: 'block',
    margin: 'auto',
    marginTop: marginTopImage,
  },
  '& .makeStyles-root-1433': {
    display: 'none',
  },
  styleTitle: {
    display: 'none',
  },
  dialogStyle: { minWidth, minHeight },
  styleButtonAcept: { minWidth: '30%' },
});

// eslint-disable-next-line react/prop-types
const MasterPage = ({ component: Component, container, ...props }) => {
  const classes = useStyles();
  const { location } = props;
  const [menuReducer, setMenuReducer] = React.useState();
  const appName = useSelector(({ general }) => general.appName);
  const history = useHistory();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [homePage, setHomePage] = useState('');
  const [connectionId, setConnectionId] = useState('');
  const [isConnected, setIsConnected] = useState(false);
  const [isValidated, setIsValidated] = useState(false);
  const [isCloseSession, setIsCloseSession] = useState(false);
  const [loading, setLoading] = useState(false);
  const [valuesMenuLeft, setValuesMenuLeft] = React.useState([]);
  const [isUserLicense, setIsUserLicense] = useState(false);
  const [alertInfo, setAlertInfo] = useState({});
  const [hasRedirected, setHasRedirected] = useState(false);
  const [isSessionValidating, setIsSessionValidating] = useState(false);
  const dialogColorIcon = theme?.miplan?.buttonCard?.backgroundColor;
  const OwnWarningIcon = useMemo(() => (
    <WarningIcon color={dialogColorIcon} />
  ), [dialogColorIcon]);
  const [token, setToken] = useState({
    result: {
      token: '',
    },
    error: {},
  });
  const jsonColorMenu = {
    primaryColor: theme.leftMenu.color,
    secondaryColor: '#ffff',
    buttonColor: '#ccfc',
    textButtonColor: '#ffa',
  };
  const getToken = (currentToken) => {
    let jwt;
    if (currentToken) {
      jwt = currentToken;
    } else {
      jwt = sessionStorage.getItem('appsUserToken');
    }

    if (jwt) {
      const jwtToken = jwt.replace('Bearer ', '');
      setToken((oldState) => ({
        ...oldState,
        result: {
          ...oldState.result,
          token: jwtToken,
        },
      }));
      const user = jwtdecode(jwtToken);
      if (user.APPS === 'LICENSE') {
        setIsUserLicense(true);
      }
      return true;
    }
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleRedirectAgreements = () => {
    setHomePage('/admin/agreements');
    history.push('/admin/agreements');
  };

  const functionMap = {
    handleRedirectAgreements,
  };

  const handleFunction = (functionName) => {
    if (functionMap[functionName]) {
      functionMap[functionName]();
    } else {
      console.log('Función no encontrada');
    }
  };
  const handleAcceptButton = () => {
    setIsCloseSession(false);
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/';
  };
  const handleAlert = (information) => {
    setAlertInfo({
      textButtonAcept: 'Aceptar',
      handleAccept: handleAcceptButton,
      messageAlert: messageStyle(theme, OwnWarningIcon, 40, '408px', '200px'),
      showClose: false,
      isOnlyMessage: false,
      mensajeModal: information,
    });
  };
  useEffect(() => {
    setLoading(true);
    const menuReducerBuilt = menuBackOfficeBuilt;
    setMenuReducer(menuReducerBuilt);
    getToken();
  }, []);

  useEffect(() => {
    if (isUserLicense) {
      if (valuesMenuLeft.length > 0) {
        if (valuesMenuLeft[0].isFunction === true) {
          const { functionName } = valuesMenuLeft[0];
          handleFunction(functionName);
        } else {
          const myUrl = new URL(valuesMenuLeft[0].url);
          const path = myUrl.pathname;
          setHomePage(path);
        }
      } else {
        setHomePage('/admin/configurations');
      }
      setLoading(false);
    }
  }, [valuesMenuLeft]);

  useEffect(() => {
    if (homePage.includes('/admin/')) {
      const protocol = new signalR.JsonHubProtocol();
      const transport = signalR.HttpTransportType.WebSockets;

      const options = {
        transport,
        skipNegotiation: true,
        logMessageContent: true,
      };

      const connection = new signalR.HubConnectionBuilder()
        .withUrl(`${API_SOCKET_ENDPOINT}/api/connections/session`, options)
        .withHubProtocol(protocol)
        .withAutomaticReconnect()
        .build();

      connection.start()
        .then(() => {
          setConnectionId(connection.connectionId);
          setIsConnected(true);

          connection.invoke('GetConnectionId').then((pConnectionId) => {
            setConnectionId(pConnectionId);
          });

          connection.on('ReceiveSessionStatus', (message) => {
            if (hasRedirected) {
              connection.stop().then(() => {
                setIsCloseSession(false);
                window.location.replace('/');
                localStorage.clear();
                sessionStorage.clear();
              }).catch((err) => {
                console.error('Error closing connection', err);
              });
            } else {
              setIsCloseSession(true);
              connection.stop().then(() => {
                handleAlert(message.message);
                console.log('Cierra la conexión del websocket');
              }).catch((err) => {
                console.error('Error closing connection', err);
              });
            }
          });
        })
        .catch((e) => console.log('Connection failed: ', e));
    }
  }, [homePage, hasRedirected]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (homePage.includes('/admin/')) {
      if (connectionId && isConnected && !isValidated) {
        const tokenSession = sessionStorage.getItem('appsUserToken');
        const validateSession = async () => {
          try {
            setIsSessionValidating(true);
            const response = await axios.post(
              `${API_SEGURIDAD}/api/user/validatesession`,
              {},
              {
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: tokenSession,
                  connectionId,
                },
              },
            );
            const result = response.data;
            if (result.statusCode === 200) {
              setIsValidated(true);
            }
          } catch (error) {
            if (error.response.status === 401 && !hasRedirected
            ) {
              window.location.replace('/');
              setHasRedirected(true);
              setIsCloseSession(false);
              setLoading(false);
              localStorage.clear();
              sessionStorage.clear();
              setIsConnected(false);
              setIsValidated(false);
            } else {
              console.error('Error al validar la sesión:', error);
            }
          } finally {
            setIsSessionValidating(false);
          }
        };
        validateSession();
      }
    }
  }, [connectionId, isConnected, isValidated, hasRedirected]);
  const drawMenu = () => (
    <>
      <div>
        {token.result.token && !!menuReducer && menuReducer.length > 0 ? (
          <>
            <Hidden xsDown>
              <LeftMenu
                open
                token={token.result.token}
                appName="license"
                setValuesMenuLeft={setValuesMenuLeft}
                drawerProps={{
                  variant: 'permanent',
                  open: true,
                  classes: {
                    paper: classes.drawer,
                  },
                }}
                version=""
                functions={[{ name: 'handleRedirectAgreements', function: handleRedirectAgreements }]}
                color={jsonColorMenu}
              />
            </Hidden>
            <Hidden smUp>
              <LeftMenu
                open
                token={token.result.token}
                appName="license"
                drawerProps={{
                  variant: 'temporary',
                  anchor: theme.direction === 'rtl' ? 'right' : 'left',
                  open: mobileOpen,
                  onClose: handleDrawerToggle,
                  ModalProps: {
                    keepMounted: true,
                  },
                  classes: {
                    paper: classes.drawer,
                  },
                }}
                version=""
                functions={[]}
                setValuesMenuLeft={setValuesMenuLeft}
              />
            </Hidden>
          </>
        ) : null}
      </div>
    </>
  );

  return (
    <>
      {appName === 'license' ? (
        <>
          <div className={classes.root}>
            <CssBaseline />
            <Header />
            {
              location.pathname.toLowerCase() !== '/myplan'
                ? (
                  <nav
                    className={`${classes.drawer} 'custom-drawer'`}
                    aria-label="mailbox folders"
                  >

                    <Hidden xsDown implementation="css">
                      <Drawer
                        classes={{
                          paper: classes.drawerPaper,
                        }}
                        variant="permanent"
                        open
                      >
                        {drawMenu()}
                      </Drawer>
                    </Hidden>
                  </nav>
                )
                : ''
            }

            <main className={classes.content}>
              <div className={classes.toolbar} />
              <br />
              <br />
              <br />
              {valuesMenuLeft && valuesMenuLeft.length > 0 && location.pathname === '/' ? (
                history.push(homePage)
              ) : (
              // eslint-disable-next-line react/jsx-props-no-spreading
                loading ? (
                  <Loading />
                ) : (
                  <Component {...props} />
                )
              )}
            </main>
          </div>
          {isSessionValidating ? (
            <Loading />
          ) : (
            isCloseSession && (
              <AlertConfirm
                isOpen={isCloseSession}
                textButtonAcept={alertInfo?.textButtonAcept}
                mensajeModal={alertInfo?.mensajeModal}
                handleAccept={alertInfo?.handleAccept}
                onCancel={alertInfo?.onCancel}
                onClose={alertInfo?.onClose}
                messageAlert={alertInfo?.messageAlert}
                showClose={alertInfo?.showClose}
                isOnlyMessage={alertInfo?.isOnlyMessage}
              />
            )
          )}
        </>
      ) : (
        <>
          {location.pathname.includes('/admin/') ? (
            history.push('/')
          ) : (
            <>
              <Header />
              <Component {...props} />
            </>
          )}
        </>
      )}
    </>
  );
};

export default MasterPage;
